import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { environment } from "src/environments/environment";


@Component({
    selector: "goto-original-dialog",
    templateUrl: "./goto-original-dialog.component.html",
    styleUrls: ['./goto-original-dialog.component.scss'],

})
export class GoToOriginalDialog {
    isLoaderEnabled: boolean = false;

    constructor(public dialogRef: MatDialogRef<GoToOriginalDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {

    }


    ngOnInit() {

    }
    onCancel(): void {
        this.dialogRef.close(null);
    }

    goToOriginalPage() {
        const url = environment.SERVER_URL + 'careers/my-profile'
        window.open(url, "_blank");
      }
}